import { Stack, styled } from '@mui/material';

import { colors } from '../theme/theme';
import { breakpoints } from '../theme/Typography';

export const VerifyOtpStyleWrapper = styled(Stack)(({ theme }) => ({
    '& .otpContainer': {
        display: 'flex',
        gap: theme.spacing(1.25),
        justifyContent: 'center',
        marginBottom: theme.spacing(3),
        '& .otpBox': {
            position: 'relative',
            '& input': {
                ...theme.typography.body1,
                [breakpoints.down('md')]: {
                    width: 34,
                    height: 34,
                    fontSize: 16,
                },
                width: 46,
                height: 46,
                textAlign: 'center',
                padding: theme.spacing(0),
                color: colors.greyPreset[80],
            },
            '& .MuiInputBase-root': {
                padding: theme.spacing(0.25),
            },
            '& .Mui-focused': {
                backgroundColor: 'transparent',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${colors.greyPreset[30]}`,
                borderRadius: theme.spacing(1),
            },
            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: colors.bluePreset[40],
            },
        },
    },
    '& .cardHeader': {
        marginBottom: theme.spacing(4),
        alignItems: 'center',
        justifyContent: 'space-between',
        '& .mainTitle': {
            color: colors.fullBlack,
        },
        '& .MuiButtonBase-root': {
            color: colors.primaryLight[100],
        },
    },
    '& .subTitle': {
        color: colors.greyPreset[80],
        marginBottom: theme.spacing(3),
        textAlign: 'center',
    },
    '& .forgotPasswordSubTitle': {
        color: colors.greyPreset[80],
        textAlign: 'center',
        marginTop: theme.spacing(1),
    },
}));
